/**
 * Tumelo defined industry categories
 */
export enum IndustryCategory {
  UNKNOWN = '0',
  AGRICULTURE_AND_FOOD = '1',
  // RESERVED: ENERGY = '2',
  FINANCE = '3',
  HEALTHCARE = '4',
  INDUSTRIAL = '5',
  LIFESTYLE = '6',
  REAL_ESTATE = '7',
  RETAIL = '8',
  TECH = '9',
  TRANSPORT_AND_VEHICLES = '10',
  // RESERVED: UTILITIES = '11',
  SPECIALIST_SERVICES = '12',
  ENERGY_AND_UTILITIES = '13',
}

/**
 * Returns the industry category Title given an industry category
 * It handles undefined / unknown industry categories
 */
export const industryCategoryToIndustryCategoryTitle = (category?: IndustryCategory): string => {
  return (category && industryCategoryToIndustryCategoryTitleMap.get(category)) || 'Uncategorised'
}

const industryCategoryToIndustryCategoryTitleMap = new Map<IndustryCategory, string>([
  [IndustryCategory.AGRICULTURE_AND_FOOD, 'Agriculture & Food'],
  [IndustryCategory.ENERGY_AND_UTILITIES, 'Energy & Utilities'],
  [IndustryCategory.FINANCE, 'Finance'],
  [IndustryCategory.HEALTHCARE, 'Healthcare'],
  [IndustryCategory.INDUSTRIAL, 'Industrial'],
  [IndustryCategory.LIFESTYLE, 'Lifestyle'],
  [IndustryCategory.REAL_ESTATE, 'Real Estate'],
  [IndustryCategory.RETAIL, 'Retail'],
  [IndustryCategory.TECH, 'Tech'],
  [IndustryCategory.TRANSPORT_AND_VEHICLES, 'Transport & Vehicles'],
  [IndustryCategory.SPECIALIST_SERVICES, 'Specialist Services'],
  [IndustryCategory.UNKNOWN, 'Uncategorised'],
])
